import { GlobeIcon } from 'lucide-react'

import { DomainOverviewContent } from '../domain-overview-content.molecule'
import type { DomainOverviewData } from '../split-view.interface'
import { registerSplitViewContent } from '../split-view.registry'

const isDomainOverviewData = (data: unknown): data is DomainOverviewData =>
  typeof data === 'object' &&
  data !== null &&
  'domain' in data &&
  typeof (data as DomainOverviewData).domain === 'string' &&
  'registeredAt' in data &&
  typeof (data as DomainOverviewData).registeredAt === 'string' &&
  'metricList' in data &&
  Array.isArray((data as DomainOverviewData).metricList)

export const registerDomainOverviewContent = (): void => {
  registerSplitViewContent<DomainOverviewData>({
    type: 'domain-overview',
    title: 'Domain Overview',
    subtitle: (data) => data.domain,
    icon: GlobeIcon,
    component: DomainOverviewContent,
    isValidData: isDomainOverviewData,
  })
}
